<template>
<div class="flex w-full flex-col items-center justify-around text-center">
  <div>
    <div class="m-2.5 text-lg font-light text-black">
      {{ $t("analyzing") }}
    </div>
    <div class="relative flex justify-center text-center">
      <div class="bg-scan absolute inset-0 mx-auto h-full w-full max-w-[70%] rounded-t-[42px] bg-[#fafafa]/70 bg-[url('./assets/scanning-cover.png')] bg-repeat"></div>
      <div class="scan-line absolute top-0 flex h-1.5 w-10/12 flex-col items-center justify-center bg-[var(--secondary)]"></div>
      <img id="preview" class="max-h-[60vh] w-full max-w-[70%] rounded-[42px]" :src="preview" />
    </div>
  </div>

  <div class="mx-3.5 mt-10 rounded bg-[#f1f1f1] p-2.5 text-black ltr:text-left rtl:text-right">
    <h2 class="m-0 text-lg font-bold">
      {{ $t("scan.authentication-tips") }}:
    </h2>
    <p class="text-base font-light">
      {{ tip }}
    </p>
  </div>
</div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

defineProps({
  preview: {
    type: String,
    required: true
  }
});
const { t } = useI18n();
const tip = ref("");

const randomTips = () => {
  const tips = [t("scan.tips.one"), t("scan.tips.two"), t("scan.tips.three"), t("scan.tips.four")];

  const randomIndex = Math.floor(Math.random() * tips.length);
  tip.value = tips[randomIndex];
};

onMounted(() => {
  randomTips();
});
</script>

<style scoped>
.bg-scan {
  animation: bgScroll 1s linear infinite;
}

.scan-line {
  animation: scan-line 1s linear infinite;
}

@keyframes scan-line {
  from {
    top: 0;
  }
  to {
    top: 99%;
  }
}

@keyframes bgScroll {
  from {
    height: 0;
    background-position: 0 0;
  }
  to {
    height: 99%;
    background-position: 0 -450px;
  }
}
</style>
